import React from 'react';
import ErrorMessage from './ErrorMessage';
import './quantityTracker.scss';

interface QuantityTrackerProps {
  quantityCount?: number,
  handleIncreaseQuantity?: React.MouseEventHandler<HTMLButtonElement>,
  handleDecreaseQuantity?: React.MouseEventHandler<HTMLButtonElement>,
  handleChangeQuantity?: React.ChangeEventHandler<HTMLInputElement>, // This connects to the onChange event on the input field - fired when a user manually inputs a value
  handleBlur?: React.FocusEventHandler<HTMLInputElement>, // This connects to the onBlur event on the input field - fired when a user clicks out of the input field
  size?: string,
  labelPosition?: string,
  min?: number,
  max?: number,
  disabled?: boolean,
  labelText?: string,
  error?: boolean,
  errorMessage?: string,
  hasDeleteOption?: boolean,
}

export const QuantityTracker = (
  {
    quantityCount = 1, 
    handleIncreaseQuantity,
    handleDecreaseQuantity,
    handleChangeQuantity,
    handleBlur,
    labelText = "Quantity", 
    size = "small", 
    labelPosition = "top", 
    min = 1,
    max = 999,    
    disabled = false, 
    error = false, 
    errorMessage = "",
    hasDeleteOption = false,
  }: QuantityTrackerProps
) => {

  const inputProps = {
    type: "number",
    name: "quantity",
    id: "quantity",
    min: min.toString(),
    max: max.toString(),
    className: `ter-quantity-tracker__input ${disabled ? " ter-quantity-tracker__input-disabled " : ""}`,
    value: quantityCount,
    onChange: handleChangeQuantity,
    onBlur: handleBlur,
    disabled: disabled ? true : false,
  }

  const renderInputField = () => {
    const hasDeleteBtn = inputProps?.value <= 1 && hasDeleteOption
    return (
      <>
        {labelText && <label htmlFor="quantity" className={`ter-quantity-tracker__label`}>{labelText}</label>}
        <div>
          <div className={`ter-quantity-tracker__input-wrapper ${disabled ? 'ter-quantity-tracker__input-disabled' : ""} ${error ? 'ter-quantity-tracker__input-wrapper--error' : ""}`}>
            <button className="ter-quantity-tracker__button ter-quantity-tracker__button--decrease" disabled={disabled || Number(inputProps?.value) <= Number(inputProps?.min)} onClick={handleDecreaseQuantity}>
              {
                hasDeleteBtn ? 
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <path fill="currentColor" d="M15.21 3.71001L14.8 3.30001C14.61 3.11001 14.36 3.01001 14.09 3.01001H9.92C9.65 3.01001 9.4 3.12001 9.21 3.30001L8.8 3.71001C8.61 3.90001 8.36 4.00001 8.09 4.00001H6C5.45 4.00001 5 4.45001 5 5.00001C5 5.55001 5.45 6.00001 6 6.00001H18C18.55 6.00001 19 5.55001 19 5.00001C19 4.45001 18.55 4.00001 18 4.00001H15.91C15.64 4.00001 15.39 3.89001 15.2 3.71001H15.21ZM8 21H16C17.1 21 18 20.1 18 19V7.00001H6V19C6 20.1 6.9 21 8 21ZM13.54 8.78001H14.46V19H13.54V8.78001ZM9.54 8.78001H10.46V19H9.54V8.78001Z" />
                    </g>
                  </svg>
                  : 
                  <svg width="14" height="2" viewBox="0 0 14 2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2H0V0H14V2Z" fill="currentColor"/>
                  </svg>
              }
            </button>
            <input {...inputProps} />
            <button className="ter-quantity-tracker__button ter-quantity-tracker__button--increase" disabled={disabled || Number(inputProps?.value) >= Number(inputProps?.max)} onClick={handleIncreaseQuantity}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="currentColor"/>
              </svg>
            </button>
          </div>
          { errorMessage && <ErrorMessage errorMessage={errorMessage} /> }
        </div>
      </>
    )
  }

  return (
    <div className={`ter-quantity-tracker__wrapper`}>
      <div className={`ter-quantity-tracker ter-quantity-tracker--${size} ter-quantity-tracker--label-${labelPosition}`}>
        {renderInputField()}
      </div>
    </div>
  )
};

export default QuantityTracker
